import { Button, useToast } from '@chakra-ui/react';
import React from 'react';

import { finleyAssert } from '@finley-technologies/common';
import { CreditAgreement } from '@finley-technologies/finley-types';

import { useSetLoanTapeSanitizeConfigsMutation } from './requests/requests.gql.generated';

export const defaultToastOptions = {
  position: 'top' as const,
  isClosable: true,
  duration: 5000,
} as const;

type SaveBaseFieldsWipButtonProps = {
  config: CreditAgreement.DataTapeField.LoanTapeSanitizeConfig | null;
  creditFacilityId: string;
  isLoading: boolean;
  isDisabled: boolean;
};
export const SaveBaseFieldsWipButton = ({
  isLoading,
  isDisabled,
  config,
  creditFacilityId,
}: SaveBaseFieldsWipButtonProps) => {
  const toast = useToast(defaultToastOptions);

  const [
    setLoanTapeSanitizeConfigsMutation,
    { loading: savingConfig },
  ] = useSetLoanTapeSanitizeConfigsMutation({
    onCompleted: (result) => {
      toast({
        ...defaultToastOptions,
        id: `${Date.now()}`,
        title: `updates saved: ${result.setLoanTapeSanitizeConfigs.response}`,
        status: 'success',
      });
    },
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error('onError:', error);
      const message = `${error}`;
      toast({
        ...defaultToastOptions,
        id: `${Date.now()}`,
        title: message,
        status: 'error',
        duration: null, // errors are important, do not auto-close
      });
    },
  });

  const onSave = () => {
    finleyAssert(config, 'config is null, button should be disabled');

    const sanitizedConfig = {
      ...config,
      baseFields: JSON.stringify(config.baseFields),
    };
    setLoanTapeSanitizeConfigsMutation({
      variables: {
        creditFacilityId,
        configs: [sanitizedConfig],
      },
    });
  };

  return (
    <Button
      border="2px"
      variant="outline"
      colorScheme="aurora"
      backgroundColor="white"
      padding="10px 24px"
      aria-label="Save"
      isLoading={isLoading || savingConfig}
      onClick={() => onSave()}
      isDisabled={isDisabled || !config}
    >
      Save Progress
    </Button>
  );
};
